import about from 'assets/icons/about_icon.svg'
import career from 'assets/img/careers_icon.svg'
import copy from 'assets/icons/copy_icon.svg'
import tick from 'assets/icons/check-mark.svg'
import arrow from 'assets/icons/arrow.png'
import arrowFilled from 'assets/icons/arrow_up.svg'
import arrowUp from 'assets/icons/arrow_up.svg'
import close from 'assets/icons/Close.svg'
import close2 from 'assets/icons/close_icon_2.svg'
import closeModal from 'assets/icons/close_modal.svg'
import leaderCrown from 'assets/icons/leader_crown.svg'
import closeOutline from 'assets/icons/close_outline.svg'
import awardStar from 'assets/icons/award_icon.svg'
import user from 'assets/icons/user_icon.svg'
import userCircle from 'assets/icons/user_icon_circle.svg'
import usd from 'assets/icons/usd_icon.svg'
import info from 'assets/icons/info_icon.svg'
import error from 'assets/icons/error_icon.svg'
import warning from 'assets/icons/warning_icon.svg'
import pending from 'assets/icons/pending_icon.svg'
import pendingYellow from 'assets/icons/pending_icon-yellow.svg'
import checkBlue from 'assets/icons/check_icon-blue.svg'
import alertRed from 'assets/icons/alert_icon-red.svg'
import checkCircle from 'assets/icons/check_icon.svg'
import liquidity from 'assets/icons/liquidity_dashboard_icon.svg'
import contest from 'assets/icons/contest_icon.svg'
import lightning from 'assets/icons/dashboard_icon.svg'
import support from 'assets/icons/support_icon.svg'
import tour from 'assets/icons/tour_icon.svg'
import crown from 'assets/icons/leader_icon.svg'
import starBadge from 'assets/icons/star_badge.svg'
import changeGraphView from 'assets/icons/change_view_icon.svg'
import xftFramed from 'assets/icons/xft_icon-only.svg'
import referral from 'assets/icons/referral_icon.svg'
import docs from 'assets/icons/docs_icon.svg'
import wallet from 'assets/icons/wallet_link_icon.svg'
import withdraw from 'assets/icons/withdraw_icon.svg'

export const general = {
  about,
  info,
  usd,
  career,
  tick,
  copy,
  arrow,
  arrowFilled,
  arrowUp,
  close,
  close2,
  closeModal,
  closeOutline,
  leaderCrown,
  awardStar,
  user,
  userCircle,
  error,
  warning,
  pending,
  pendingYellow,
  checkBlue,
  alertRed,
  checkCircle,
  liquidity,
  contest,
  lightning,
  support,
  tour,
  crown,
  starBadge,
  changeGraphView,
  xftFramed,
  referral,
  docs,
  wallet,
  withdraw,
}
